import { render, staticRenderFns } from "./AdminGraphite.vue?vue&type=template&id=2dacd5ac&scoped=true&"
import script from "./AdminGraphite.vue?vue&type=script&lang=js&"
export * from "./AdminGraphite.vue?vue&type=script&lang=js&"
import style0 from "./AdminGraphite.vue?vue&type=style&index=0&id=2dacd5ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dacd5ac",
  null
  
)

export default component.exports